<template>
	<v-container fluid id="consultas-container" class="d-flex flex-column">
		<v-btn-toggle style="width: 100%;" v-if="!$vuetify.breakpoint.mobile">
			<GlobalNewButton class="mr-2"/>
			<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 2 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(2)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Listado</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Adicionales</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 3 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(3)">
				<div class="d-flex align-start">
					<v-icon>mdi-text-box-check-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Tabla Informativa</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Adicionales</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 4 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(4)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Listado</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Posibles Adicionales</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 5 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(5)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Listado Finalizados</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Posibles Adicionales</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 6 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(6)">
				<div class="d-flex align-start">
					<v-icon>mdi-file-document-edit-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
					</div>
				</div>
			</v-btn>
			<!-- <v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 5 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_additionals'])"
				@click="changeListing(4)">
				<v-icon>mdi-chart-areaspline</v-icon>
				<p class="mb-0 ml-2 font-weight-bold text-capitalize">Estadísticas</p>
			</v-btn> -->
		</v-btn-toggle>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
					rounded
					color="#2D4B95"
					dark
					small
					block
          v-bind="attrs"
          v-on="on"
        >
          Seleccione Opción
        </v-btn>
      </template>
			<div class="d-flex flex-column pa-2 white" style="gap: 5px;">
				<GlobalNewButton :fullWidth="true"/>
				<v-divider class="my-1"></v-divider>
				<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 2 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_additionals'])"
					@click="changeListing(2)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Listado</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Adicionales</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 3 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_additionals'])"
					@click="changeListing(3)">
					<div class="d-flex align-start">
						<v-icon>mdi-text-box-check-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Tabla Informativa</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Adicionales</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 4 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_additionals'])"
					@click="changeListing(4)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Listado</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Posibles Adicionales</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 5 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_additionals'])"
					@click="changeListing(5)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Listado Finalizados</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Posibles Adicionales</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.adicionalesStore.state.selectedType === 6 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_additionals'])"
					@click="changeListing(6)">
					<div class="d-flex align-start">
						<v-icon>mdi-file-document-edit-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
						</div>
					</div>
				</v-btn>
			</div>
    </v-menu>
		<div v-if="checkPermissions(['view_additionals'])">
			<ListadoAdicionales
				ref="listadoAdicionales"
				v-if="this.$store.adicionalesStore.state.selectedType === 2"/>
			<ListadoAdditionalLikely
				ref="listadoPosibleAdicionales"
				v-if="this.$store.adicionalesStore.state.selectedType === 4 || this.$store.adicionalesStore.state.selectedType === 5"/>
			<TablaInformativaAdicionales
				ref="tablaInformativaAdicionales"
				v-if="this.$store.adicionalesStore.state.selectedType === 3"/>
			<ListadoBorradores
				v-if="this.$store.adicionalesStore.state.selectedType === 6"
				:draftType="3"
				@loadDraft="loadDraft"
			/>
		</div>
		<div v-else class="d-flex flex-column align-center justify-center" style="height: 100%;min-height: 300px;">
			<v-icon size="50" color="grey lighten-1">mdi-lock</v-icon>
			<p class="text-center mt-2 mb-0 text--grey">No tienes permisos para ver los Adicionales.</p>
			<p class="text-center caption text--grey">Contacta con el administrador del proyecto.</p>
		</div>
	</v-container>
</template>

<script>
import ListadoAdicionales from './ListadoAdicionales'
import ListadoAdditionalLikely from './ListadoAdditionalLikely'
import TablaInformativaAdicionales from './TablaInformativaAdicionales'
import ListadoBorradores from '@/components/Globals/Helpers/ListadoBorradores'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'
import {exportAdditionalStatusByProject, exportAdditionalPaymentStatusByProject} from '@/helpers/api/additionals'
import { getTareaByID } from '@/helpers/api/tasks'

export default {
	name: 'RdiContainer',
	components: {ListadoAdicionales, ListadoAdditionalLikely, TablaInformativaAdicionales, ListadoBorradores, GlobalNewButton},
	computed: {
		selectedProject(){
			return this.$store.projectsStore.state.selectedProject
		},
		listing_type(){
			return this.$route.params.listing_type || this.$route.query.listing_type
		}
	},
	watch: {
		selectedProject(newVal, oldVal){
			if(!newVal?.id || newVal.id === oldVal?.id) return
			const selectedType = this.$store.adicionalesStore.state.selectedType
			if(selectedType === 4) this.getAdditionalLikelyList()
			else if(selectedType === 5) this.getAdditionalLikelyList({status: 3})
			else if(selectedType === 3) this.getAdditionalInformativeTable()
			else if(selectedType === 2) this.getAdditionalList()
		},
		listing_type(newType){
			if(newType){
				this.changeListing(parseInt(newType))
			}
		}
	},
	data: () => ({
		createTareaModal: false,
		loadingExport: false
	}),
	mounted(){
		if(this.listing_type){
			this.changeListing(parseInt(this.listing_type))
		}
		else{
			this.getAdditionalList()
		}
		// if(!this.checkPermissions(['view_additionals'])){
		// 	this.$store.rdiStore.commit('setSelectedType', 0)
		// }
	},
	methods: {
		loadDraft(draft){
			const draftType = draft.raw_type
			
			if(draftType === 3) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.$store.adicionalesStore.commit('setCreateAdicionalModal', true)
			}
			else if(draftType === 4) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', true)
			}
			else if(draftType === 7) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.viewAdditional(draft.morphable_id)
			}
			else if(draftType === 8) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.viewTarea(draft.morphable_id)
			}
			else if(draftType === 10) {
				this.$store.adicionalesStore.commit('setDraftToLoad', draft)
				this.viewAdditional(draft.morphable_id)
			}
		},
		viewAdditional(additional_id){
			this.$store.adicionalesStore.commit('setCurrentAdicional', {loading: true})
			this.$store.adicionalesStore.dispatch('getAdditionalByID', {
				additional_id,
				seen_by_me: false
			})
		},
		async viewTarea(task_id){
			this.$store.consultasStore.commit('setCurrentTarea', {loading: true, is_posible_additional: true})
			const tarea = await getTareaByID({task_id})
			if(tarea.code === 200){
				let tareaData = tarea.task
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		changeListing(selected){
			if(this.$store.adicionalesStore.state.selectedType != selected){
				this.$router.push({name: 'Adicionales', query: {listing_type: selected}})
				this.$store.adicionalesStore.commit('setSelectedType', selected)
				if(selected == 4){
					this.getAdditionalLikelyList()
				}
				else if(selected == 5){
					this.getAdditionalLikelyList({status: 3})
				}
				else if(selected == 3){
					this.getAdditionalInformativeTable()
				}
				else if(selected == 2){
					this.getAdditionalList()
				}
			}
		},
		async getAdditionalLikelyList(params = {}){
			// if(this.checkPermissions(['view_additionals'])){
				let project_id = null
				if(this.$store.projectsStore.state.selectedProject){
					project_id = this.$store.projectsStore.state.selectedProject.id
				}
				else{
					const id = localStorage.getItem('selectedProjectID')
					project_id = parseInt(id)
				}
				if(project_id){
					const dispatchPayload = {project_id, ...params}
					this.$store.adicionalesStore.dispatch('getAdditionalsLikely', dispatchPayload)
				}
			// }
		},
		async getAdditionalList(){
			// if(this.checkPermissions(['view_additionals'])){
				let project_id = null
				if(this.$store.projectsStore.state.selectedProject){
					project_id = this.$store.projectsStore.state.selectedProject.id
				}
				else{
					const id = localStorage.getItem('selectedProjectID')
					project_id = parseInt(id)
				}
				if(project_id){
					this.$store.adicionalesStore.dispatch('getAdditionals', {project_id})
				}
			// }
		},
		async getAdditionalInformativeTable(){
			// if(this.checkPermissions(['view_additionals'])){
				let project_id = null
				if(this.$store.projectsStore.state.selectedProject){
					project_id = this.$store.projectsStore.state.selectedProject.id
				}
				else{
					const id = localStorage.getItem('selectedProjectID')
					project_id = parseInt(id)
				}
				if(project_id){
					this.$store.adicionalesStore.dispatch('getAdditionalInformativeTable', {project_id})
				}
			// }
		},
		async excelExport(){
			this.loadingExport = true
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id
			}
			const exportAdditionals = await exportAdditionalStatusByProject(data)
			if(exportAdditionals.code == 200){
				window.open(exportAdditionals.url);
			}
			this.loadingExport = false
		},
		async excelExportPayments(){
			this.loadingExport = true
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id
			}
			const exportAdditionals = await exportAdditionalPaymentStatusByProject(data)
			if(exportAdditionals.code == 200){
				window.open(exportAdditionals.url);
			}
			this.loadingExport = false
		}
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
		text-align: left;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
</style>
<style>
	.custom-speed-dial-export .v-speed-dial__list{
		align-items: end;
	}
</style>